export const headerConfig = {
  headerTitle: 'Payments',
  headerDescription: 'Application Payment',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
